import axios from "axios";

class UserService {
    static BASE_URL = "https://usermanagementsystem-497524552274.us-central1.run.app";

    static async login(email, password) {
        try {
            const response = await axios.post(`${UserService.BASE_URL}/auth/login`, { email, password });
            // Store token and role in localStorage
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("role", response.data.role); // Assuming your response has the role
            return response.data; // Ensure this returns { token, role, message }
        } catch (err) {
            console.error("Login error:", err.response ? err.response.data : err.message);
            throw err; // This will bubble up the error
        }
    }

    static async register(userData) {
        console.log("Registering user with data:", userData); // Log user data
        try {
            const response = await axios.post(`${UserService.BASE_URL}/auth/register`, userData, {
                headers: { 'Content-Type': 'application/json' } // Set Content-Type header
            });
            console.log("Registration response:", response.data); // Log the server response
            return response.data; // Return the full response data
        } catch (err) {
            console.error("Registration error:", err.response ? err.response.data : err.message);
            throw err; // Propagate the error to the calling function
        }
    }
    
    

    static async getAllUsers(token) {
        try {
            const response = await axios.get(`${UserService.BASE_URL}/admin/get-all-users`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return response.data; // Return users data directly
        } catch (err) {
            console.error("Get users error:", err.response ? err.response.data : err.message);
            throw err;
        }
    }

    static async getYourProfile(token) {
        try {
            const response = await axios.get(`${UserService.BASE_URL}/adminuser/get-profile`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // Extract the user object from the response data
            return response.data; // Adjust to access the user object properly based on your backend response
        } catch (err) {
            console.error("Get profile error:", err.response ? err.response.data : err.message);
            throw err;
        }
    }

    static async getUserById(userId, token) {
        try {
            const response = await axios.get(`${UserService.BASE_URL}/admin/get-users/${userId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return response.data; // Return user data directly
        } catch (err) {
            console.error("Get user by ID error:", err.response ? err.response.data : err.message);
            throw err;
        }
    }

    static async deleteUser(userId, token) {
        try {
            const response = await axios.delete(`${UserService.BASE_URL}/admin/delete/${userId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return response.data; // Return delete confirmation
        } catch (err) {
            console.error("Delete user error:", err.response ? err.response.data : err.message);
            throw err;
        }
    }

    static async updateUser(userId, userData, token) {
        try {
            const response = await axios.put(`${UserService.BASE_URL}/admin/update/${userId}`, userData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return response.data; // Return updated user data
        } catch (err) {
            console.error("Update user error:", err.response ? err.response.data : err.message);
            throw err;
        }
    }

    /** AUTHENTICATION CHECKER */
    static isAuthenticated() {
        const token = localStorage.getItem("token");
        return token !== null; // Returns true if the token exists
    }

    /** AUTHORIZATION CHECKER */
    static adminOnly() {
        const role = localStorage.getItem("role");
        return role === "ADMIN"; // Check for "ADMIN" role
    }

    /** LOGOUT */
    static logout() {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
    }
}

export default UserService;
